export default __webpack_public_path__ + "static/media/shippingCenter.317ceddc.jpg";